import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { CollectionCard } from '../collection-card.model';

@JsonObject('CollectionCardsResultsResponse')
export class CollectionCardsResultsResponse extends ApiResultsResponse<CollectionCard> {

  @JsonProperty('results', [CollectionCard])
  override results: CollectionCard[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
